import WebApi from "@/views/loyalty/shared/modules/web_api"

export class QrCodeEndpoint {
    constructor () {
        this.url = `${process.env.VUE_APP_LOYALTY_URL}api/qrcode/`
        this.webApi = new WebApi()
    }

    async get_qrcode (item) {
        const qrcode = await this.webApi.post(`${this.url}`, { item: item })
        return qrcode
    }
}
